const actionTypes = {
  SET_SUER_INFO_DETAIL: 'setUserInfoDetail',
  SET_USER_INFO_ITEM: 'setUserInfoItem',
  SET_PARAMS: 'setParams',
  SET_TOTAL_COUNT: 'setTotalCount',
  SET_EDIT_MODEL_STATUS: 'setEditModelStatus',
  SET_ADD_MODEL_STATUS: 'setAddModelStatus',
}

export default actionTypes
